<script setup lang="ts">
import { computed } from "vue";
import { useMySupportSession } from "../api/use-platform";
import { usePlatformI18n } from "../i18n/use-platform-i18n";

/**
 * Whoever is read, sees.
 *
 * This band is the half of the design V2's master password never had: while
 * anyone from support has permission to look at this workspace, the people
 * working in it know, know why, and know until when. It vanishes by itself when
 * the grant expires or is revoked — which is why the query repeats instead of
 * being made once on load.
 *
 * The REASON is shown exactly as it was written, never translated: it is the
 * sentence someone put their name to, and paraphrasing it here would be this
 * product editing an explanation it did not give.
 */
const props = defineProps<{ enabled: boolean }>();

const { data: session } = useMySupportSession(() => props.enabled);
const { t, locale } = usePlatformI18n();

const until = computed(() =>
	session.value
		? new Date(session.value.expiresAt).toLocaleTimeString(locale.value, {
				hour: "2-digit",
				minute: "2-digit",
			})
		: "",
);
</script>

<template>
	<div
		v-if="session"
		class="flex flex-wrap items-center gap-x-2 gap-y-1 border-b border-warning/30 bg-warning-subtle px-3 py-1.5 text-xs text-warning sm:px-5"
		role="status"
	>
		<span class="font-medium">{{ t("support.bannerUntil", { time: until }) }}</span>
		<span class="text-fg-muted">
			{{ t("support.bannerReason", { reason: session.reason })
			}}{{
				session.grantedByName
					? t("support.bannerGrantedBy", { name: session.grantedByName })
					: ""
			}}.
		</span>
	</div>
</template>
